import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * React Router doesn't reset the browser scroll position on route changes by
 * default — new pages open at whatever offset the previous page was scrolled
 * to. On a marketing site this means clicking any link on a long page (Home)
 * lands the user near the footer of the destination page instead of the top.
 *
 * Mounting this component once (inside <BrowserRouter>) forces the window to
 * scroll to top on every pathname change.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
